export function formatMoney(
  money: number,
  currency: string,
  minimumFractionDigits: number = 0,
  maximumFractionDigits: number = minimumFractionDigits,
) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(money);
}
